import { JSX } from "react";
import "./Styles.scss";
import { appContext } from "../../../AppContext";
import Helper from "../../../Common/Helper";
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";
import Menu from "./Menu";
import { IRouterProps, withRouting } from "@iconics/components";
import { SerendieSymbol } from "@serendie/symbols";
import { Divider, NotificationBadge, Tooltip } from "@serendie/ui";
import { ThemeId } from "../../../Common/CustomTheme";
import LegacyApiClient, { IFile } from "../../../Providers.Api/LegacyApiClient";
import { Button, GridContainer, GridItem, Typography } from "@iconics/components";

export class Header extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private get session() { return appContext().sessionStorageProvider; }
    private get local() { return appContext().localStorageProvider; }
    private get appState() { return appContext().state; }
    private get apiClient() { return appContext().apiClient; }

    constructor(props: IProps)
    {
        super(props);
        this.state = {
            title: appContext().state.pageTitle,
            backUrl: appContext().state.backUrl,
            type: "",
            customerLogo: [],
            themeId: appContext().state.themeId,
            numOfNewNotifications: appContext().state.numOfNewNotifications,
        };
    }

    public async componentDidMount(): Promise<void>
    {
        this.appState.autoMap(this, i => ({
            title: i.pageTitle,
            backUrl: i.backUrl,
            themeId: i.themeId,
            numOfNewNotifications: i.numOfNewNotifications,
        }));

        if (this.state.customerLogo.length == 0)
        {
            this.getCustomerLogo();
        }

        this.setState({ type: this.local.getUserDetails().userType });
    }

    private async getCustomerLogo(): Promise<void>
    {
        try 
        {
            const getCustomerLogo = await LegacyApiClient.getFiles('c/logo');
            const customerLogoPath = getCustomerLogo.map((item: IFile) =>
            {
                let newItem = { ...item }
                newItem.path = `${Helper.getStorageUrl()}/images/c/logo/${item.name}`
                return newItem
            })
            await this.setStateAsync({ customerLogo: customerLogoPath })
        } catch (error) 
        {
        }
    }

    private handleShowNotifications(): void
    {
        this.props.navigate('/notifications');
    }

    public render(): JSX.Element
    {
        const { numOfNewNotifications } = this.state;
        const { customerLogo } = this.state;

        const logoPath = customerLogo ?
            (customerLogo.find(logo => logo && logo.path?.includes("light")))?.path
            : null;

        return (
            <GridContainer
                className="header"
                spacing={2}
            >
                <GridItem
                    compact={6}
                >
                    <GridContainer
                        spacing={2}
                        style={{ paddingLeft: '24px' }}
                    >
                        {
                            this.state.backUrl &&
                            <GridItem
                                className="header__back"
                                compact='auto'
                            >
                                <SerendieSymbol
                                    name="arrow-left"
                                    onClick={() => this.props.navigate(this.state.backUrl)}
                                />
                            </GridItem>
                        }
                        <GridItem
                            className='header_page-title'
                            compact='auto'
                        >
                            <Typography role='headline' size='large'>
                                {this.state.title}
                            </Typography>
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem
                    compact={6}
                >
                    <GridContainer
                        spacing={2}
                        className="header__account"
                        style={{
                            paddingRight: '48px',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <GridItem
                            compact='auto'
                        >
                            {logoPath && (
                                <img
                                    src={logoPath}
                                    alt="company logo"
                                    height="50"
                                    className="mr-10"
                                />
                            )}
                        </GridItem>
                        <GridItem
                            className="header__settings"
                            compact='auto'
                        >
                            <Menu />
                        </GridItem>
                        <GridItem
                            className="header__settings"
                            compact='auto'
                        >
                            <Tooltip content={this.labels.HubMenuNotifications}>
                                <div>
                                    <Button
                                        className="header__notification-button"
                                        aria-label="notifications"
                                        styleType='ghost'
                                        onClick={() => this.handleShowNotifications()}
                                    >
                                        <SerendieSymbol name='bell' />
                                    </Button>
                                    <NotificationBadge
                                        className='header__notification-circle'
                                        count={numOfNewNotifications}
                                    />
                                </div>
                            </Tooltip>
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem
                    compact={12}
                    className="header__divider"
                >
                    <Divider
                        color="light"
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

export default withRouting(Header);
export interface IProps extends IRouterProps { }

export interface IState
{
    title: string;
    backUrl: string;
    type: string;
    customerLogo: IFile[];
    themeId: ThemeId;
    numOfNewNotifications: number;
}
